import React, { useCallback, useRef, useState } from "react";
import ConfirmationModal from "./ConfirmationModal";

// Promise-based stand-in for window.confirm() that uses the app's own dialog:
//   const [confirmDialog, ask] = useConfirm();
//   if (!(await ask({ title, message, confirmLabel }))) return;
//   ...render {confirmDialog} somewhere in the component.
export default function useConfirm() {
  const [options, setOptions] = useState(null);
  const resolveRef = useRef(null);

  const ask = useCallback(
    (opts) =>
      new Promise((resolve) => {
        resolveRef.current = resolve;
        setOptions(opts);
      }),
    []
  );

  const settle = (answer) => {
    resolveRef.current?.(answer);
    resolveRef.current = null;
    setOptions(null);
  };

  const dialog = (
    <ConfirmationModal
      isOpen={!!options}
      title={options?.title}
      message={options?.message}
      confirmLabel={options?.confirmLabel}
      cancelLabel={options?.cancelLabel}
      onConfirm={() => settle(true)}
      onClose={() => settle(false)}
    />
  );

  return [dialog, ask];
}
